import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { ScheduleAction } from './schedule.action';
import { scheduleInitialState } from './schedule.constant';
import { IScheduleStore } from './schedule.interface';

export const scheduleReducer = reducerWithInitialState(scheduleInitialState)
  .case(ScheduleAction.load.started, (state, params): IScheduleStore => {
    const { data } = state;
    const { scheduleId } = params;

    return {
      ...state,
      data: {
        ...data,
        [params.scheduleId]: {
          ...data[scheduleId],
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(ScheduleAction.load.done, (state, payload): IScheduleStore => {
    const { data } = state;
    const { params, result } = payload;

    return {
      ...state,
      data: {
        ...data,
        [params.scheduleId]: {
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(ScheduleAction.load.failed, (state, payload): IScheduleStore => {
    const { data } = state;
    const { params: { scheduleId } } = payload;
    const scheduleData = data[scheduleId];

    return {
      ...state,
      data: {
        ...data,
        [scheduleId]: {
          ...scheduleData,
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(ScheduleAction.loadList.started, (state): IScheduleStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Started,
    };
  })
  .case(ScheduleAction.loadList.done, (state, payload): IScheduleStore => {
    const data = {};

    for (const item of payload.result) {
      data[item.scheduleId] = {
        ...state.data[item.scheduleId],
        ...item,
      };
    }

    return {
      ...state,
      data,
      listNetworkStatus: NetworkStatus.Done,
    };
  })
  .case(ScheduleAction.loadList.failed, (state): IScheduleStore => {
    return {
      ...state,
      listNetworkStatus: NetworkStatus.Failed,
    };
  })
  .case(ScheduleAction.remove.done, (state, payload): IScheduleStore => {
    const { data } = state;
    const { params: { scheduleId } } = payload;

    delete data[scheduleId];

    return {
      ...state,
      data: {
        ...data,
      },
    };
  })
  .case(ScheduleAction.destroy, () => ({
    ...scheduleInitialState,
  }));
